import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`text-xl md:text-2xl font-bold font-heading tracking-tight ${
              scrolled || !isHome ? 'text-primary-600' : 'text-background-50'
            }`}>
              免费韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50/90 hover:text-background-50'
              } ${location.pathname === '/' ? (scrolled || !isHome ? 'text-primary-600' : 'text-background-50') : ''}`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50/80 hover:text-background-50'
                } ${location.pathname.includes(cat.slug) ? (scrolled || !isHome ? 'text-primary-600' : 'text-background-50') : ''}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50/80 hover:text-background-50'
              } ${location.pathname === '/about' ? (scrolled || !isHome ? 'text-primary-600' : 'text-background-50') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-background-50'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4 px-4">
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 cursor-pointer py-2">首页</Link>
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm font-medium text-foreground-700 hover:text-primary-600 cursor-pointer py-2"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-600 cursor-pointer py-2">关于我们</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}